export default __webpack_public_path__ + "static/media/logo_3.0120ce1f.png";